import React from 'react';
import './index.scss';

interface ConditionCarouselWidgetCardProps {
    title: string;
    imageUrl: string;
}

const ConditionCarouselWidgetCard = (props: ConditionCarouselWidgetCardProps) => {
    return (
        <div className='condition-carousel-card'>
            <img width={'110px'} height={'110px'} alt={`${props.title} image`} src={props.imageUrl} />
            <pui-text textsize='double-extra-large' textalign='center' fontweight='bold' input={props.title}></pui-text>
        </div>
    );
};

export default ConditionCarouselWidgetCard;
